var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { SetServiceAction, VideoAddAction, VideoDeleteAction, VideosReorderAction, } from '../store/service/reducer';
import { environment } from '../../environments/environment';
import { AuthHttpService } from '../services/auth-http.service';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { RequestErrorAction } from '../store/serviceUi/reducer';
import { requestErrorMap, requestFieldMap } from './pipes';
import { REQUEST_SERVICE_UPDATE, REQUEST_VIDEO_ADD, REQUEST_VIDEO_DELETE, REQUEST_VIDEO_REORDER, } from '../store/service/constants';
import { Observable } from 'rxjs/internal/Observable';
import { LOCALE_PREFIX } from '../configs';
var responseFieldMap = function (errorMessage) {
    return function (res) {
        if (res.hasError) {
            return new RequestErrorAction({ errorMessage: errorMessage, field: res.field });
        }
        return new SetServiceAction({ res: res.res.res, field: res.res.field });
    };
};
var ɵ0 = responseFieldMap;
var responseMediaMap = function (errorMessage, field, ResAction) {
    return function (res) {
        if (res.hasError) {
            return new RequestErrorAction({ errorMessage: errorMessage, field: field });
        }
        return new ResAction(res.res);
    };
};
var ɵ1 = responseMediaMap;
var ServiceEffects = /** @class */ (function () {
    function ServiceEffects(actions$, authHttp) {
        var _this = this;
        this.actions$ = actions$;
        this.authHttp = authHttp;
        this.baseUrl = "" + environment.urlPrefix + LOCALE_PREFIX + "/update_api/api/service";
        this.updateField$ = this.actions$.pipe(ofType(REQUEST_SERVICE_UPDATE), mergeMap(function (action) {
            return _this.authHttp
                .patch(_this.baseUrl + "/" + action.payload.id + "/", (_a = {},
                _a[action.payload.key] = action.payload.value,
                _a))
                .pipe(requestFieldMap(action.payload.key), requestErrorMap(action.payload.key));
            var _a;
        }), map(responseFieldMap('Error during service update.')));
        this.addVideo$ = this.actions$.pipe(ofType(REQUEST_VIDEO_ADD), mergeMap(function (action) {
            var _a = action.payload, service = _a.service, video = _a.video;
            return _this.authHttp
                .post(_this.baseUrl + "/" + service.id + "/video/", video)
                .pipe(requestErrorMap());
        }), map(responseMediaMap('Could not add video.', 'videos', VideoAddAction)));
        this.deleteVideo$ = this.actions$.pipe(ofType(REQUEST_VIDEO_DELETE), mergeMap(function (action) {
            var _a = action.payload, service = _a.service, video = _a.video;
            var url = _this.baseUrl + "/" + service.id + "/video/" + video.id + "/";
            return _this.authHttp.delete(url).pipe(map(function () { return video.id; }), requestErrorMap());
        }), map(responseMediaMap('Could not delete video.', 'videos', VideoDeleteAction)));
        this.reorderVideos$ = this.actions$.pipe(ofType(REQUEST_VIDEO_REORDER), switchMap(function (action) {
            var _a = action.payload, service = _a.service, ids = _a.ids;
            return _this.authHttp
                .patch(_this.baseUrl + "/" + service.id + "/reorder_videos/", ids)
                .pipe(requestErrorMap());
        }), map(responseMediaMap('Could not reorder videos.', 'videos', VideosReorderAction)));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ServiceEffects.prototype, "updateField$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ServiceEffects.prototype, "addVideo$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ServiceEffects.prototype, "deleteVideo$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ServiceEffects.prototype, "reorderVideos$", void 0);
    return ServiceEffects;
}());
export { ServiceEffects };
export { ɵ0, ɵ1 };
